import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sampleSearch',
  standalone:true
})
export class SampleSearchPipe implements PipeTransform {

  transform(value: any, searchText:String): any {

    return (searchText != '') ? value.filter((item:any) => {  
      return item?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.user?.lastname.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.user?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.reference?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.tool?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.amount?.toString()?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.owner_detail?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.owner_detail?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.invited_detail?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.invited_detail?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.creator?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.creator?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.sender?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.sender?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.receiver?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.receiver?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.updator?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.updator?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.instructor?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.instructor?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.deliver?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.deliver?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.client?.lastname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.client?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.customer?.lasstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.customer?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.seller?.lasstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.seller?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.provider?.user?.lasstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.provider?.user?.firstname?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.amount?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.amount?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.created_at?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.order?.update_at?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.created_at?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.updated_at?.toLowerCase().includes(searchText.toLowerCase()) ||
              item?.type?.toLowerCase().includes(searchText.toLowerCase())||
              item?.duration?.toLowerCase().includes(searchText.toLowerCase())||
              item?.description?.toLowerCase().includes(searchText.toLowerCase())||
              item?.country?.name?.toLowerCase().includes(searchText.toLowerCase())||
              item?.code?.toLowerCase().includes(searchText.toLowerCase())||
              item?.phone_code?.toLowerCase().includes(searchText.toLowerCase())||
              item?.currency?.toLowerCase().includes(searchText.toLowerCase())||
              item?.currency_symbol?.toLowerCase().includes(searchText.toLowerCase())||
              item?.capital?.toLowerCase().includes(searchText.toLowerCase())||
              item?.continent?.toLowerCase().includes(searchText.toLowerCase())||
              item?.continent_code?.toLowerCase().includes(searchText.toLowerCase())||
              item?.alpha3?.toLowerCase().includes(searchText.toLowerCase())||
              item?.price?.toLowerCase().includes(searchText.toLowerCase())||
              item?.level?.toLowerCase().includes(searchText.toLowerCase())||
              item?.currency?.toLowerCase().includes(searchText.toLowerCase())||
              item?.visibility?.toLowerCase().includes(searchText.toLowerCase())||
              item?.job_title?.toLowerCase().includes(searchText.toLowerCase())||
              item?.currency?.toLowerCase().includes(searchText.toLowerCase())||
              item?.experience_years?.toLowerCase().includes(searchText.toLowerCase())||
              item?.location?.toLowerCase().includes(searchText.toLowerCase())||
              item?.contract_type?.toLowerCase().includes(searchText.toLowerCase())||
              item?.education_level?.toLowerCase().includes(searchText.toLowerCase())||
              item?.phoneNumber?.toLowerCase().includes(searchText.toLowerCase())||
              item?.isAvailable?.toLowerCase().includes(searchText.toLowerCase())||
              item?.deliveries_count?.toLowerCase().includes(searchText.toLowerCase())||
              item?.location?.lat.toLowerCase().includes(searchText.toLowerCase())||
              item?.location?.lng.toLowerCase().includes(searchText.toLowerCase())||
              item?.address?.toLowerCase().includes(searchText.toLowerCase())||
              item?.emailAddress?.toLowerCase().includes(searchText.toLowerCase())||
              item?.phoneNumber?.toLowerCase().includes(searchText.toLowerCase())||
              item?.shelf?.name?.toLowerCase().includes(searchText.toLowerCase())||
              item?.price?.toLowerCase().includes(searchText.toLowerCase())||
              item?.promotional_price?.toLowerCase().includes(searchText.toLowerCase())||
              item?.quantity?.toLowerCase().includes(searchText.toLowerCase())||
              item?.category?.name?.toLowerCase().includes(searchText.toLowerCase())||
              item?.store?.name?.toLowerCase().includes(searchText.toLowerCase())||
              item?.rating?.name?.toLowerCase().includes(searchText.toLowerCase())||
              item?.experience?.toLowerCase().includes(searchText.toLowerCase())||
              item?.price_per_hour?.toLowerCase().includes(searchText.toLowerCase())||
              item?.date_time?.toLowerCase().includes(searchText.toLowerCase())||
              item?.total_price?.toLowerCase().includes(searchText.toLowerCase())||
              item?.user?.phone_number?.toLowerCase().includes(searchText.toLowerCase())||
              item?.mini?.toLowerCase().includes(searchText.toLowerCase())||
              item?.maxi?.toLowerCase().includes(searchText.toLowerCase())||
              item?.value?.toLowerCase().includes(searchText.toLowerCase())||
              item?.fees?.toLowerCase().includes(searchText.toLowerCase())||
              item?.motif?.toLowerCase().includes(searchText.toLowerCase())||
              item?.wallet_before?.toLowerCase().includes(searchText.toLowerCase())||
              item?.action?.toLowerCase().includes(searchText.toLowerCase())||
              item?.wallet?.amount?.toLowerCase().includes(searchText.toLowerCase())||
              item?.origin?.toLowerCase().includes(searchText.toLowerCase())||
              item?.manage_by?.toLowerCase().includes(searchText.toLowerCase())
    }) : value;
  }

 

}